export default "__VITE_ASSET__BDrOHm3R__"